<script setup>
import { computed } from 'vue';

const props = defineProps({
  name: { type: String, required: true },
  size: { type: String, default: 'md' },
});

// Classes stay explicit in this map so the icon font build can discover them.
const ICONS = {
  inboxes: 'i-ph-tray',
  voip_calls: 'i-ph-phone-call',
  agents: 'i-ph-user',
  teams: 'i-ph-users-three',
  custom_roles: 'i-ph-shield-check',
  assignment: 'i-ph-share-network',
  canned: 'i-ph-quotes',
  labels: 'i-ph-tag',
  macros: 'i-ph-lightning',
  automation: 'i-ph-lightning',
  workflows: 'i-ph-git-branch',
  sla: 'i-ph-clock',
  captain: 'i-ph-sparkle',
  agent_bots: 'i-ph-robot',
  lead_scoring: 'i-ph-chart-bar',
  general: 'i-ph-gear-six',
  attributes: 'i-ph-list-bullets',
  billing: 'i-ph-credit-card',
  audit: 'i-ph-scroll',
  integrations: 'i-ph-plugs-connected',
  profile: 'i-ph-user-circle',
  security: 'i-ph-lock-key',
  kanban_stages: 'i-ph-kanban',
  kanban_automations: 'i-ph-lightning',
  kanban_agenda: 'i-ph-calendar-blank',
  kanban_ai: 'i-ph-sparkle',
  kanban_access: 'i-ph-user-check',
  kanban_appearance: 'i-ph-eye',
  kanban_offers: 'i-ph-package',
  kanban_integrations: 'i-ph-paper-plane-tilt',
  kanban_data: 'i-ph-arrows-down-up',
  task_labels: 'i-ph-tag',
  task_templates: 'i-ph-copy',
  task_views: 'i-ph-list-checks',
  default: 'i-ph-sliders-horizontal',
};

const iconClass = computed(() => ICONS[props.name] || ICONS.default);
const sizeClass = computed(() => (props.size === 'sm' ? 'size-3.5' : 'size-4'));
</script>

<template>
  <span
    class="inline-flex shrink-0 items-center justify-center text-n-slate-10 transition-transform duration-150 ease-out motion-safe:group-hover/icon-area:-translate-y-0.5 motion-safe:group-focus-visible/icon-area:-translate-y-0.5 motion-reduce:transform-none motion-reduce:transition-none"
    aria-hidden="true"
  >
    <span class="block" :class="[sizeClass, iconClass]" />
  </span>
</template>
